
import dayjs from "dayjs"
import countDown from "@/components/order/countDown.vue"
import imgView from "@/components/order/imgView.vue"
import drawerHeader from "@/components/drawer/components/drawerHeader.vue"
import { priceFormat } from "@/utils/utils"
import collapseTransition from "@/library/collapse-transition.js"
import { cancelOrder, deleteOrder, buyAgain, getCancelReason, getRelatedOrderList, getReceipt } from "@/api/order.js"
import { getRootStyle } from "@/utils/head"
const week = ["Sun", "Mon", "Tue", "Wed", "Thur", "Fri", "Sat"]
const month = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
export default {
  components: {
    countDown,
    collapseTransition,
    imgView,
    drawerHeader
  },
  props: {
    orderList: {
      type: Array,
      default: () => []
    },
    isAppOder: {
      type: Boolean,
      default: false
    },
    hadRequest: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      lang: this.$i18n.locale,
      showDes: true,
      list: [],
      curVisible: false,
      appendToBody: false,
      cancleTitle: "Cancle order",
      reasonOptions: [],
      reason: "",
      curClickOrderItem: null,
      loadingInstance: null,
      relatedInfo: {},

      reasonPlaceholder: "Please Make a choice"
    }
  },
  computed: {},
  watch: {
    orderList: {
      handler(newVal) {
        this.list = this.mapStatus(newVal)
      }
      // immediate: true
    },
    hadRequest: {
      handler(newVal) {},
      immediate: true
    }
  },
  created() {},
  methods: {
    priceFormat,
    titleClick() {
      this.showDes = !this.showDes
    },

    fen2Yuan(num) {
      if (isNaN(num)) return ""
      num = Number(num)
      return (num / 100).toFixed(2)
    },
    getNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res[0]
    },
    getSmallNumber(nums) {
      const num = this.fen2Yuan(nums)
      const str = num.toString()
      const res = str.split(".")
      return res.length === 2 ? res[1] : ""
    },
    getViewDate(date) {
      date = dayjs(Number(date)).format("YYYY-MM-DD HH:mm")
      return date
    },
    goShopping() {
      this.$navigation.push({
        path: "/"
      })
    },
    // 重组 订单状态图标和订单状态颜色 ， 操作按钮颜色
    mapStatus(list) {
      const { brand500, progressSuccessColor, primaryColor } = getRootStyle()
      list.forEach(item => {
        item.orderStatusSvg = "info"
        item.orderStatusColor = "#000"
        // 待支付1
        if ([1].includes(item.orderStatus)) {
          item.orderStatusSvg = "info"
          item.orderStatusColor = brand500
          item.orderStatusSvgColor = brand500
        }
        // 已支付 9 等待生產16
        if ([9, 16].includes(item.orderStatus)) {
          item.orderStatusSvg = "coin"
          item.orderStatusColor = brand500
          item.orderStatusSvgColor = brand500
        }
        // 生產中,揀貨中 10
        if ([10].includes(item.orderStatus)) {
          item.orderStatusSvg = "box"
          item.orderStatusColor = brand500
          item.orderStatusSvgColor = brand500
        }
        // 拣货完成14
        if ([14].includes(item.orderStatus)) {
          item.orderStatusSvg = "note"
          item.orderStatusColor = brand500
          item.orderStatusSvgColor = brand500
        }
        // 送貨中 12
        if ([12].includes(item.orderStatus)) {
          item.orderStatusSvg = "deliveryCarRight"
          item.orderStatusColor = brand500
          item.orderStatusSvgColor = brand500
        }
        // 已完成4 ,自提已完成5
        if ([4, 5].includes(item.orderStatus)) {
          item.orderStatusSvg = "complete"
          item.orderStatusColor = progressSuccessColor
        }

        // 訂單取消 6
        if ([6].includes(item.orderStatus)) {
          item.orderStatusSvg = "closeCircle"
          item.orderStatusColor = "#969696"
        }
        // 自提 13
        if ([13].includes(item.orderStatus)) {
          item.orderStatusSvg = "readytopickup"
          item.orderStatusSvgBIg = "readytopickupBig"
          item.orderStatusColor = progressSuccessColor
          item.orderStatusSvgColor = progressSuccessColor
        }
        // 按钮颜色

        if (item.orderBtnInfoList) {
          item.orderBtnInfoList.forEach(it => {
            if (it) {
              it.btnBgColor = "#ffffff"
              it.btnColor = primaryColor
              // // "立即支付" 11
              // if ([11].includes(it.btnTag)) {
              //   it.btnBgColor = primaryColor
              //   it.btnColor = "#ffffff"
              // }
              // // "再次购买" 61
              // if ([61].includes(it.btnTag)) {
              //   it.btnBgColor = primary100
              //   it.btnColor = odrerByAgainColor
              // }
            }
          })
        }
        // 商品 & 赠品组装为一个列表
        if (item.giftList && item.giftList.length) {
          item.wareAndGiftList = [...item.itemList, ...item.giftList]
        } else {
          item.wareAndGiftList = [...item.itemList]
        }
      })
      return list
    },
    async btnClick(it, item) {
      this.curClickOrderItem = item
      // 11, "立即支付"
      if (it.btnTag == 11) {
        if (item.orderTagObj && item.orderTagObj.relatedOrderIds && item.orderTagObj.relatedOrderIds.length >= 2) {
          this.$messageBox
            .open({
              title: "",
              message: this.$t("orderDetails.pendingPaymentTips"),
              cancelText: this.$t("orderDetails.cancel"),
              confirmText: this.$t("orderDetails.confirmP")
            })
            .then(() => {
              this.$navigation.push({
                path: "/pending_payment",
                query: {
                  orderNo: item.orderId,
                  orderList: item.orderTagObj.relatedOrderIds.join(",")
                }
              })
            })
            .catch(res => {
              console.log(res)
            })
        } else {
          this.$navigation.push({
            path: "/pending_payment",
            query: {
              orderNo: item.orderId
            }
          })
        }
      }
      // contact us
      if (it.btnTag == 21) {
        const contactUsLink = this.$t("footer.contactUsLink")
        window.open(contactUsLink)
      }
      // buy again
      if (it.btnTag == 61) {
        try {
          const res = await buyAgain({
            param: JSON.stringify({
              sort: 1,
              orderId: item.orderId
            })
          })
          const { message, showBtn } = res.data
          if (message) {
            this.$messageBox
              .open({
                title: this.$t("orderDetails.buyAgain"),
                message,
                cancelText: this.$t("orderDetails.stayHere"),
                confirmText: this.$t("orderDetails.goToCart"),
                showButton: showBtn
              })
              .then(res => {
                this.$navigation.push({ path: "/cart" })
              })
              .catch(res => {
                console.log(res)
              })
          }
        } catch (error) {
          console.log("buy again failed", error)
        }
      }
      // 查看收据
      if (it.btnTag == 96 || it.btnTag == 97) {
        this.handleReceipt()
      }
    },
    handleReceipt() {
      window.open(`${this.MAIN_ORIGIN}${this.MAIN_PATH}/receipt?orderId=${this.curClickOrderItem.orderId}`, "_blank")
    },
    goOrderDetails(data) {
      if (this.isAppOder) {
        return
      }
      this.$navigation.push({
        path: "/order_details",
        query: {
          orderId: data.orderId
        }
      })
    },

    curCount(count, index, item) {
      this.$set(this.list[index], "curCount", count)
    }
  }
}
